import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { BATTLESHIP, EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
const EmptyShoppingCartText = styled(Small).withConfig({
  displayName: "EmptyShoppingCart__EmptyShoppingCartText",
  componentId: "sc-17weyfe-0"
})(["width:100%;max-width:140px;color:", ";text-align:center;"], EERIE);
const EmptyShoppingCartContainer = styled(UIFlex).withConfig({
  displayName: "EmptyShoppingCart__EmptyShoppingCartContainer",
  componentId: "sc-17weyfe-1"
})(["height:330px;color:", ";"], BATTLESHIP);

function EmptyShoppingCart() {
  return /*#__PURE__*/_jsxs(EmptyShoppingCartContainer, {
    direction: "column",
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "store-disabled",
      width: "125px",
      className: "m-bottom-4"
    }), /*#__PURE__*/_jsx(EmptyShoppingCartText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.shoppingCart.emptyCart"
      })
    })]
  });
}

export default EmptyShoppingCart;